import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";

const Trips = lazy(() => import("@/pages/agent/crm/trips/Trips/Trips"));
const TripDetail = lazy(() => import("@/pages/agent/crm/trips/TripDetail/TripDetail"));
const PersonalBookings = lazy(() => import("@/pages/agent/crm/personal-bookings/PersonalBookings/PersonalBookings"));

// const Bookings = lazy(() => import("@/pages/agent/crm/bookings/Bookings/Bookings"));
// const EditBooking = lazy(() => import("@/pages/agent/crm/bookings/EditBooking/EditBooking"));
// const Payments = lazy(() => import("@/pages/agent/crm/payments/Payments/Payments"));

const Groups = lazy(() => import("@/pages/agent/crm/groups"));
// const GroupPayments = lazy(() => import("@/pages/agent/crm/groups/payments/GroupPayments"));
const AddGroup = lazy(() => import("@/pages/agent/crm/groups/new"));
const EditGroup = lazy(() => import("@/pages/agent/crm/groups/[:id]/edit"));
const GroupDetail = lazy(() => import("@/pages/agent/crm/groups/[:id]"));

const Clients = lazy(() => import("@/pages/agent/crm/clients/Clients/Clients"));
const TripAuthorizations = lazy(() => import("@/pages/agent/crm/client-forms/trip-authorizations/TripAuthorizations"));
const ServiceAuthorizations = lazy(
  () => import("@/pages/agent/crm/client-forms/service-authorizations/ServiceAuthorizations"),
);
const InformationRequests = lazy(
  () => import("@/pages/agent/crm/client-forms/information-requests/InformationRequests"),
);
const BulkUpload = lazy(() => import("@/pages/agent/crm/clients/bulk-upload/BulkUpload/BulkUpload"));
const EditProfile = lazy(() => import("@/pages/agent/crm/clients/EditProfile/EditProfile"));
const InformationRequest = lazy(() => import("@/pages/agent/crm/clients/InformationRequest/InformationRequest"));
const ClientAuthorizationOld = lazy(() => import("@/pages/agent/crm/clients/ClientAuthorization/ClientAuthorization"));
const EditClientAuthorization = lazy(
  () => import("@/pages/agent/crm/client-forms/trip-authorizations/EditClientAuthorization"),
);
const CreateClientAuthorization = lazy(
  () => import("@/pages/agent/crm/client-forms/trip-authorizations/CreateClientAuthorization"),
);
const ServiceAuthorization = lazy(() => import("@/pages/agent/crm/clients/ServiceAuthorization/ServiceAuthorization"));
const EditServiceAuthorization = lazy(
  () => import("@/pages/agent/crm/client-forms/service-authorizations/EditServiceAuthorization"),
);

// new one
const ClientAuthorization = lazy(
  () => import("@/pages/agent/crm/client-authorization/ClientAuthorization/ClientAuthorization"),
);

const Itineraries = lazy(() => import("@/pages/agent/crm/itineraries/Itineraries/Itineraries"));
const EditItinerary = lazy(() => import("@/pages/agent/crm/itineraries/EditItinerary/EditItinerary"));

const Error404 = lazy(() => import("@/pages/Error404"));

const crmRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "client-authorization",
    children: [
      {
        index: true,
        element: <Error404 />,
      },
      {
        path: "new",
        element: <ClientAuthorization />,
      },
    ],
  },
  {
    path: "client-forms",
    children: [
      {
        index: true,
        element: <Error404 />,
      },
      {
        path: "trip-authorizations",
        children: [
          {
            index: true,
            element: <TripAuthorizations />,
          },
          {
            path: "new",
            element: <CreateClientAuthorization />,
          },
          {
            path: ":id",
            element: <EditClientAuthorization />,
          },
        ],
      },
      {
        path: "service-authorizations",
        children: [
          {
            index: true,
            element: <ServiceAuthorizations />,
          },
          {
            path: ":id",
            element: <EditServiceAuthorization />,
          },
        ],
      },
      {
        path: "information-requests",
        element: <InformationRequests />,
      },
    ],
  },
  {
    path: "clients",
    children: [
      {
        index: true,
        element: <Clients />,
      },
      {
        path: ":profileId",
        children: [
          {
            index: true,
            element: <EditProfile />,
          },
          {
            path: "information-request",
            element: <InformationRequest />,
          },
          {
            path: "client-authorization",
            element: <ClientAuthorizationOld />,
          },
          {
            path: "service-authorization",
            element: <ServiceAuthorization />,
          },
        ],
      },
      {
        path: "bulk-upload",
        element: <BulkUpload />,
      },
    ],
  },
  {
    path: "trips",
    children: [
      {
        index: true,
        element: <Trips />,
      },
      {
        path: ":tripId",
        element: <TripDetail />,
      },
    ],
  },
  {
    path: "personal-bookings",
    element: <PersonalBookings />,
  },
  {
    // Backwards-compatible redirect for the old /crm/nets URL.
    path: "nets",
    element: <Navigate to="/crm/personal-bookings" replace />,
  },
  // {
  //   path: "bookings",
  //   children: [
  //     {
  //       index: true,
  //       element: <Bookings />,
  //     },
  //     {
  //       path: ":id",
  //       element: <EditBooking />,
  //     },
  //   ],
  // },
  // {
  //   path: "payments",
  //   children: [
  //     {
  //       index: true,
  //       element: <Payments />,
  //     },
  //   ],
  // },
  {
    path: "groups",
    children: [
      {
        index: true,
        element: <Groups />,
      },
      {
        path: ":id",
        children: [
          {
            index: true,
            element: <GroupDetail />,
          },
          {
            path: "edit",
            element: <EditGroup />,
          },
        ],
      },
      // {
      //   path: "payments",
      //   children: [
      //     {
      //       index: true,
      //       element: <Error404 />,
      //     },
      //     {
      //       path: ":id",
      //       element: <GroupPayments />,
      //     },
      //   ],
      // },
      {
        path: "new",
        element: <AddGroup />,
      },
    ],
  },
  {
    path: "itineraries",
    children: [
      {
        index: true,
        element: <Itineraries />,
      },
      {
        path: ":id",
        element: <EditItinerary />,
      },
    ],
  },
];

export default crmRoutes;
